<template>
    <div class="container">
        <form class="content" @submit.prevent="submitData">
            <fieldset>
                <label for="youtube">Youtube</label>
                <input type="text" id="youtube" v-model="sociales.youtube" placeholder="URL">
            </fieldset>
            <fieldset>
                <label for="instagram">Instagram</label>
                <input type="text" id="instagram" v-model="sociales.instagram" placeholder="URL">
            </fieldset>
            <fieldset>
                <label for="facebook">Facebook</label>
                <input type="text" id="facebook" v-model="sociales.facebook" placeholder="URL">
            </fieldset>
            <fieldset>
                <label for="whatsapp">Whatsapp</label>
                <input type="text" id="whatsapp" v-model="sociales.whatsapp" placeholder="URL">
            </fieldset>

            <div class="button-message">
                <p :style="{ '--textColor': statusItem.success ? '#A9CA80' : '#FF6967' }">{{ statusItem.message }}</p>
                <button type="submit">Guardar</button>
            </div>
        </form>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            sociales: {
                whatsapp: '',
                youtube: '',
                instagram: '',
                facebook: ''
            },

            statusItem: {
                success: null,
                message: '',
            }
        }
    },

    async created() {
        const response = await this.getAllInfoScs('sociales');
        if (response.success && response.result.length > 0) {
            this.sociales = response.result[0];
        }
    },

    methods: {
        ...mapActions('sociales', ['getAllInfoScs']),

        async submitData() {
            const ruta = this.sociales.id ? 'sociales/editItemScs' : 'sociales/addItemScs';
            this.clearStatus();
            try {
                const response = await this.$store.dispatch(ruta, {
                    option: 'sociales',
                    item: this.sociales
                })

                if (!response.success) throw response;

                this.statusItem.success = true;
                this.statusItem.message = 'Redes sociales actualizadas con éxito';

                setTimeout(() => {
                    this.clearStatus();
                }, 5000);
            } catch (error) {
                this.statusItem.success = false;
                this.statusItem.message = error.message;
            }
        },

        clearStatus() {
            this.statusItem = {
                success: null,
                message: '',
            }
        }
    }
}
</script>
<style scoped>
*,
*::before,
*::after {
    box-sizing: border-box;
}

.container {
    padding-right: 6.7708vw;
}

.content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    gap: .7813vw;
}

fieldset {
    display: grid;
    justify-items: start;
    background-color: var(--color-2);
    border: none;
    transition: background-color 0.3s ease;

    border-radius: .7813vw;
    padding: 1.0417vw;
    gap: .7813vw;
}

fieldset:hover,
fieldset:has(input:focus-visible) {
    background-color: var(--color-6);
}

fieldset input {
    width: 100%;
    transition: background-color 0.3s ease;
    background-color: var(--color-5);
    color: var(--color-6);

    font-size: .9375vw;
    height: 1.5625vw;
    padding: 0 .5208vw;
    border-radius: .2604vw;
}

label {
    color: var(--color-5);
    font-size: .9375vw;
}

.button-message {
    grid-column: 2 / 3;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;

    gap: .2604vw;
}

button {
    border: none;
    justify-self: end;
    background-color: var(--color-2);
    cursor: pointer;
    transition: background-color 0.3s ease;
    color: var(--color-5);

    font-size: .9375vw;
    width: 10.4167vw;
    height: 2.0833vw;
    border-radius: 1.0417vw;
}

button:hover {
    background-color: var(--color-6);
}

.button-message p {
    color: var(--textColor)
}
</style>